module.exports = __webpack_public_path__ + "04af4809c1fcaee6ec3a91ac3eee7d8e.png";